module.exports = __webpack_public_path__ + "img/2_b.77a809c1.jpg";